export function debounce<F extends (...args: any[]) => void>(func: F, wait: number) {
  let timeout: ReturnType<typeof setTimeout> | null;

  const debounced = (...args: Parameters<F>): void => {
    if (timeout) clearTimeout(timeout);
    timeout = setTimeout(() => {
      func(...args);
    }, wait);
  };

  // allow cancelling
  debounced.cancel = () => {
    if (timeout) clearTimeout(timeout);
  };

  return debounced;
}
